import React, { useState } from "react";
import {
  Box,
  Tabs,
  Tab,
  Typography,
  Button,
  Divider,
  AppBar,
} from "@mui/material";
import axios from "axios";
import { getItem, setItem } from "../../utils/DataProtection";
import { useDispatch } from "react-redux";
import { config_UPTIME } from "../../Constants";

const API_URL = config_UPTIME.url.API_URL + "/userinfo/update";


const AccountSettings = ({ userInfo, userId, userNodeId }) => {

  const dispatch = useDispatch();


  const handleResetVisibility = async (featureName, feature) => {
    try {
      const persisted = getItem("persisted_content_configurations");
      let fullConfig = persisted
        ? JSON.parse(persisted)
        : { ...userInfo?.contentconfigurations };

      // 1. Updated path: Target visibilitySettings[userNodeId] directly
      const userSettings = fullConfig.visibilitySettings?.[userNodeId];

      if (userSettings && Array.isArray(userSettings)) {
        // 2. Filter out the specific feature
        const updatedList = userSettings.filter(
          (item) => item.feature !== featureName,
        );

        // 3. Re-assign directly to the userNodeId key
        fullConfig.visibilitySettings[userNodeId] = updatedList;
      }

      const user_token = getItem("user");
      await axios.post(
        API_URL,
        {
          userid: userId,
          userinfo: { contentConfigurations: fullConfig },
        },
        {
          headers: { Authorization: "Bearer " + JSON.parse(user_token) },
        },
      );

      // DISPATCH THE ALERT
      dispatch({
        type: "SHOW_SNACKBAR",
        payload: {
          open: true,
          title: "Erfolg",
          description: `${feature} wurde erfolgreich zurückgesetzt.`,
          severity: "success",
        },
      });

      setItem("persisted_content_configurations", JSON.stringify(fullConfig));
    } catch (err) {
      console.error("Failed to reset visibility", err);
    }
  };

  return (
    <Box sx={{ pt: 1 }}>
      {/* Info-Hinweise Section */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Box>
          <Typography className="cms_account_setting_tab_content_title">
            Info-Hinweise
          </Typography>
          <Typography className="cms_account_setting_tab_content_description">
            Erhalten Sie hilfreiche Hinweise zur Nutzung der Software in den
            jeweiligen Bereichen.
          </Typography>
        </Box>
        <Button
          variant="outlined"
          onClick={() => handleResetVisibility("ScopeHeader", "Hinweise")}
          className="cms_account_setting_tab_content_button"
        >
          ANZEIGE ZURÜCKSETZEN
        </Button>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Leistungskennzahlen Section (KPIs) */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box>
          <Typography className="cms_account_setting_tab_content_title">
            Leistungskennzahlen
          </Typography>
          <Typography className="cms_account_setting_tab_content_description">
            Erhalten Sie nützliche Einblicke in die Leistung Ihrer Werke und
            Equipments.
          </Typography>
        </Box>
        <Button
          variant="outlined"
          onClick={() =>
            handleResetVisibility("Dashboard_KPI_Cards", "Leistungskennzahlen")
          }
          className="cms_account_setting_tab_content_button"
        >
          ANZEIGE ZURÜCKSETZEN
        </Button>
      </Box>
    </Box>
  );
};

export default AccountSettings;
